export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9007.f304c1f2.jpg";